import { useRouteDocumentTitle } from '@client/toolkit';
import { useTranslation } from 'react-i18next';
import { DashboardPaths } from '../dashboard.router';
import { PageContentAnimation } from '../../../components/layout/page-content-animation';
import { WidgetsGrid } from '../../../components';
import { OutstandingPaymentWidget, VacancyCostWidget, BuildingNetYieldWidget } from './components/index';
import { DashboardFilters } from '../components';
import { DateRangePresetKey } from '../components/DashboardFilters/useDefaultDateRangePresets';

export const DashboardEconomyViewRoute = () => {
  const { t: routeT } = useTranslation('dashboard');
  useRouteDocumentTitle(routeT('dashboard.economical.documentTitle'), DashboardPaths.Economical);
  return (
    <PageContentAnimation className="flex flex-col gap-8">
      <DashboardFilters
        visiblePresets={[
          DateRangePresetKey.YTD,
          DateRangePresetKey.LASTYEAR,
          DateRangePresetKey.LAST12MONTHSROLLING,
          DateRangePresetKey.LAST6MONTHSROLLING,
        ]}
        defaultPresetKey={DateRangePresetKey.YTD}
      />
      <WidgetsGrid type="single-column">
        <OutstandingPaymentWidget />
        <VacancyCostWidget />
        <BuildingNetYieldWidget />
      </WidgetsGrid>
    </PageContentAnimation>
  );
};
